import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["source"];

  copy() {
    navigator.clipboard.writeText(this.sourceTarget.value);

    // Optional: show a small visual feedback
    const btn = this.element.querySelector("button");
    if (btn) {
      const originalText = btn.innerHTML;
      btn.innerHTML = `<svg class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"></path></svg> Copied!`;
      setTimeout(() => {
        btn.innerHTML = originalText;
      }, 2000);
    }
  }
}
